import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getFormNode } from 'common/entities/formNode/selectors';
import { updateFormNodeValue } from '../../../actions/nodeActions';
import { HELPER_TEXT_LABEL } from '../../../constants/formStyleLabels';
import DraftTextEditorWrapper from './DraftTextEditorWrapper';
import disableWhenLocked from './disableWhenLocked';

const INPUT_PLACEHOLDER = 'Enter Value';

/**
 * The view to edit label for a question.
 */
const HelperTextControl = ({ helperText, defaultValue, onChange, disabled }) => (
    <DraftTextEditorWrapper
        fullWidth
        label={HELPER_TEXT_LABEL}
        value={helperText}
        placeholder={INPUT_PLACEHOLDER}
        disabled={disabled}
        onChangeLabel={(event, value, valueMarkup) => onChange(valueMarkup)}
    />
);

HelperTextControl.propTypes = {
    helperText: PropTypes.string,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    /** disabled is passed when form node editing is locked */
    disabled: PropTypes.bool.isRequired,
};

HelperTextControl.defaultProps = {
    helperText: null,
    defaultValue: null,
};

// -------------------
// Connected component

const mapStateToProps = (state, props) => {
    const formNode = getFormNode(state, props.formNodeId);
    return {
        helperText: props.formNodeId ? formNode.helperText : '',
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onChange: (helperText) => dispatch(updateFormNodeValue(ownProps.formNodeId, 'helperText', helperText)),
});

const ConnectedHelperTextControl = connect(mapStateToProps, mapDispatchToProps)(disableWhenLocked(HelperTextControl));

ConnectedHelperTextControl.propTypes = {
    formNodeId: PropTypes.string,
};
ConnectedHelperTextControl.defaultProps = {
    formNodeId: undefined,
};

export default ConnectedHelperTextControl;
